// Рисунки, таблицы, листинги (агент tables_figures_code). Подробности - в модулях:
//   figures/ - вставка (Ctrl+V, перетаскивание, файлы, URL, изображения проекта), ручки размера в см, поворот,
//              обрезка, замена, замещающий текст, заимствование, предупреждения о разрешении;
//   tables/  - сетка и диалог вставки, вставка из Excel/Word/Google/CSV, мини-панель, ширины граф мышью,
//              головка, выравнивание граф по СТО, прочерки, сортировка, «№ п/п» -> боковик, живые правила;
//   code/    - листинги в CodeMirror, «```», код из IDE и файлов, определение языка, ASCII-кавычки, правила 6.1;
//   keys.ts  - навигация у подписей (Enter/Tab/↓/Backspace).
import type { RegistryApi } from '../../core/registry';
import { registerIcons } from './icons';
import { setupFigures } from './figures';
import { setupTables } from './tables';
import { setupCode } from './code';
import { CaptionKeys } from './keys';
import './tfc.css';

export default function setup(r: RegistryApi) {
  registerIcons();
  setupFigures(r);
  setupTables(r);
  setupCode(r);
  r.extensions.add({ id: 'tfc.captionKeys', create: () => CaptionKeys });
}
